export default __webpack_public_path__ + "static/assets/e4bb5388ad198f29326f4549eebc918b.png";